import { StatusBadge } from "@components/display/StatusBadge";
import { CATEGORIE_TICKET } from "../../config/statuses";

interface TicketCategoryBadgeProps {
  category: string;
  size?: "sm" | "md";
}

export function TicketCategoryBadge({ category, size = "sm" }: TicketCategoryBadgeProps) {
  return <StatusBadge status={category} config={CATEGORIE_TICKET} size={size} />;
}
